/**
 * QUICK ANSWERS. Three questions and three answers, all of it static copy.
 *
 * There is no FAQ operation and no FAQ table anywhere on any of the six specifications, and that is
 * ruled rather than missing: LOCKED D37 says "the S2-migrated FAQ still ships as static pages"
 * (`docs/design/00-scope-v1.md`). So this component reads the catalogue (`support:answers.*`, in
 * the order ../strings.ts keeps) and nothing else, and it has exactly one state.
 *
 * A `<dl>` rather than a list of cards with bold text: a question and its answer ARE a description
 * list, and a screen reader that is told so can move between the pairs.
 *
 * ★ EACH PAIR A CARD, AS THE PROTOTYPE DRAWS IT (the owner's live look at real cabinets, 2026-10-01
 * / design 15): the question bold with a gold question mark before it, the answer quiet under it
 * and indented to the question's words. The mark is decoration; the `dt` says it is a question.
 */
import { Stack } from '@mantine/core';
import { CircleHelp } from '@moonx/ui';
import { useTranslation } from '../../../i18n';
import { QUICK_ANSWERS } from '../strings';
import classes from '../support.module.css';

export function QuickAnswers() {
  const { t } = useTranslation('support');
  return (
    <Stack gap={10} component="dl" style={{ margin: 0 }}>
      {QUICK_ANSWERS.map((answer) => (
        <div key={answer.key} className={classes.answerCard}>
          <dt className={classes.question}>
            <CircleHelp size={15} aria-hidden="true" />
            {t(`answers.${answer.key}.question`)}
          </dt>
          <dd className={classes.answer}>{t(`answers.${answer.key}.answer`)}</dd>
        </div>
      ))}
    </Stack>
  );
}
